import template from './keyword.html';
import '../keyword.scss';

/**
 * @ngdoc controller
 * @name OdsKeyword
 * @description
 * This component renders a keyword.
 */
class OdsKeyword {
  /**
   * Initialize variables.
   */
  $onInit() {
    if (typeof this.showRemove !== 'boolean') {
      this.showRemove = true;
    }
  }
}

/**
 * @ngdoc component
 * @name OdsKeyword
 * @description
 * The keyword component.
 */
export default {
  /**
   * The controller class for the component.
   * @type {OdsKeyword}
   */
  controller: OdsKeyword,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {Boolean}  isAutomatic  if the keyword was automatically added.
   * @property {String}   keyword      the keyword to display.
   * @property {Boolean}  showRemove   if we should show the remove button or not.
   * @property {Function} onRemove     the callback when the user removes the keyword.
   */
  bindings: {
    isAutomatic: '<',
    keyword: '<',
    showRemove: '<',
    onRemove: '&',
  },
};
